import { useEffect, useState } from 'react';

import { CastType } from './types';

/**
 * Detects the available casting technology (AirPlay or Chromecast) on the client.
 * Uses `useEffect` instead of a plain utility function to avoid accessing `window`
 * during server-side rendering, where it is undefined.
 */
export function useCastType() {
  const [castType, setCastType] = useState<CastType>();

  useEffect(() => {
    if ('WebKitPlaybackTargetAvailabilityEvent' in window) {
      setCastType(CastType.AIRPLAY);
    } else if ('chrome' in window) {
      setCastType(CastType.CHROMECAST);
    }
  }, []);

  return castType;
}
